<template>
	<div>
	<b-row>
      <b-col sm="12">
        <b-card class="card-accent-warning">
					<!-- Title -->
          <h1>{{ title }}</h1>

          <b-row class="mb-3">
            <b-col class="d-flex justify-content-end">
							<!-- Create -->
              <b-button
								v-if="create"
                variant="warning"
                @click="$emit('create')"
								class="mr-2"
                ><i class="fa fa-plus-circle"></i> {{ createText }} </b-button
              >
							<!-- Download -->
             <!--  <b-button
								v-if="download"
                variant="primary"
                @click="$emit('download')"
                ><i class="fa fa-download"></i> Download </b-button
              > -->
            </b-col>
          </b-row>

					<!-- Slot -->
					<slot />
        </b-card>
      </b-col> 
		</b-row>
	</div>
</template>

<script>
export default {
	props:{
		title:{
			type: String,
			default: 'Page Title'
		},
		create: {
			type: Boolean,
			default: true
		},
		download: {
			type: Boolean,
			default: true
		},
		createText: {
			type: String,
			default: "New"
		},
		
	},
}
</script>